import { externalLinkClickHandler } from "./factset-links";
import { FactSetWidget } from "./FactsetWidget";

type CalendarEventsDetailProps = {
  identifier: string;
};

export function CalendarEventDetail({ identifier }: CalendarEventsDetailProps) {
  return (
    <FactSetWidget
      config={[
        { type: "attribute", key: "identifier", value: identifier },
        { type: "attribute", key: "identifierInput", value: "tickerRegion" },
        {
          type: "attribute",
          key: "criteria",
          value: { criteria: [{ instruments: { ids: [identifier] } }] },
        },
        {
          type: "event",
          key: "external-link-click",
          value: externalLinkClickHandler,
        },
      ]}
      widget="calendar-event-detail"
    />
  );
}
